import * as requestFromServer from "./notificationTemplateCrud";
import {
  superAdminNotificationTemplateSlice,
  callTypes
} from "./notificationTemplateSlice";
import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = superAdminNotificationTemplateSlice;

export const fetchNotificationTemplates = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findNotificationTemplate(queryParams)
    .then(response => {
      const {
        data: { total_items, items }
      } = response.data;
      dispatch(actions.notificationTemplatesFetched({ total_items, items }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const findNotificationTemplateById = id => dispatch => {
  if (!id) {
    return dispatch(
      actions.notificationTemplateFetched({
        notificationTemplateForEdit: undefined
      })
    );
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .findNotificationTemplateById(id)
    .then(response => {
      const { data } = response.data;
      dispatch(
        actions.notificationTemplateFetched({
          notificationTemplateForEdit: data
        })
      );
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createNotificationTemplate = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createNotificationTemplate(payload)
    .then(response => {
      dispatch(actions.notificationTemplateReload);
      return response;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error.response.data;
    });
};

export const updateNotificationTemplate = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateNotificationTemplate(payload)
    .then(response => {
      dispatch(actions.notificationTemplateReload);
      return response;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error.response.data;
    });
};

export const updateStatusNotificationTemplate = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusNotificationTemplate(payload)
    .then(response => {
      dispatch(actions.notificationTemplateReload);
      return response;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error.response.data;
    });
};

export const deleteNotificationTemplate = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteNotificationTemplate(id)
    .then(response => {
      dispatch(actions.notificationTemplateReload);
      return response;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      // dispatch(actions.catchError({ error, callType: callTypes.list }));
      dispatch(actions.catchError());
      return error.response;
    });
};
